import { $t } from "@/lib/i18nHelpers";
import { ListField } from "@/types";
export const systemName = "masspay";

export const listField: ListField = { value: systemName, text: $t("MassPay") };
